import { render, staticRenderFns } from "./LegacyDomainRegistrationService.vue?vue&type=template&id=270738e9&"
import script from "./LegacyDomainRegistrationService.vue?vue&type=script&lang=js&"
export * from "./LegacyDomainRegistrationService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports